<template>
  <div class="nt-contact">
    <slot name="text"></slot>
    <div class="nt-contact__form">
      <slot name="input"></slot>
      <button @click="onsubmit">
        <slot name="button"></slot>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nt-contact',
  props: {
    urlApi: {
      type: String,
      required: true
    }
  },
  methods: {
    onsubmit() { }
  }
}
</script>
